import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DESIGNER_PATH = "/designer";

const useWatchOpenedTabs = () => {
  const location = useLocation();
  useEffect(() => {
    // define increment counter part
    const tabsOpenCount = localStorage.getItem("tabsOpenCount");
    if (!location.pathname.includes(DESIGNER_PATH)) {
      if (tabsOpenCount == null) {
        localStorage.setItem("tabsOpenCount", 1);
      } else {
        localStorage.setItem("tabsOpenCount", parseInt(tabsOpenCount) + parseInt(1));
      }
    }

    const handleBeforeUnload = () => {
      const newTabCount = parseInt(localStorage.getItem("tabsOpenCount"), 10);
      if (!isNaN(newTabCount) && !location.pathname.includes(DESIGNER_PATH)) {
        localStorage.setItem("tabsOpenCount", newTabCount - 1);
      }
    };

    // define decrement counter part
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
};

export default useWatchOpenedTabs;
